import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { Subscription } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetMySubscription = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const { authData } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const getMySubscription = useCallback(() => {
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/me',
      method: 'get',
      timeout: 15000,
    };
    return request(url, (response: unknown) => {
      const data = (response as SuccessHttpResponse<Subscription>).data;
      dispatch(subscriptionActions.setActiveSubscription(data));
    }, setLoading, (err: AxiosError<ErrorHttpResponse>) => {
      console.error('Error fetching subscription:', err?.message);
      dispatch(subscriptionActions.setActiveSubscription(null));
      dispatch(subscriptionActions.setSubscriptionError('Unable to load your subscription. Please try again.'));
    });
  }, [dispatch, request]);

  useEffect(() => {
    if (authData) {
      getMySubscription();
    }
  }, [authData, getMySubscription]);

  return { getMySubscription, loading };
};

export default useGetMySubscription;
